// extracted by css-extract-rspack-plugin
export default {"cls1":"CollapsedActivity-cls1_6fI","cls2":"CollapsedActivity-cls2_5PO CollapsedActivity-cls1_6fI"};